import type { ClassNameProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import ModalProvider from '@swf/core/providers/ModalProvider';

import type { HelpSection } from '../../types/Cashier';
import ErrorHandler from '../ErrorHandler/ErrorHandler';
import HelpSectionContainer from '../HelpSectionContainer/HelpSectionContainer';

import { gridLayout, layout, leftSection, rightSection } from './Layout.scss';
import type { HeaderPropsProp } from './components/Header/Header';
import Header from './components/Header/Header';

type Props = Partial<ClassNameProp> &
  HeaderPropsProp & {
    showFooter?: boolean;
    applyGridLayout?: boolean;
    helpSection?: HelpSection;
    limitsSection?: HelpSection;
  };

const Layout: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  children,
  className,
  headerProps,
  applyGridLayout,
  helpSection,
  limitsSection
}) => (
  <ModalProvider>
    <ErrorHandler>
      <div className={classNames(layout, className, { [gridLayout]: applyGridLayout })}>
        <Header {...headerProps} />
        {applyGridLayout ? (
          <div className={classNames({ [gridLayout]: applyGridLayout })}>
            <section>
              <div className={rightSection}>
                <main>{children}</main>
              </div>
              <div className={leftSection}>
                <HelpSectionContainer helpSection={helpSection} />
                {limitsSection && <HelpSectionContainer helpSection={limitsSection} />}
              </div>
            </section>
          </div>
        ) : (
          <section>
            <main>{children}</main>
          </section>
        )}
      </div>
    </ErrorHandler>
  </ModalProvider>
);

export default Layout;
